package fr.frux.core.ads

import androidx.compose.runtime.staticCompositionLocalOf
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Contrôleur publicitaire de l'application, installé par `FruxCompositionRoot` depuis le graphe
 * (#527). Les écrans le lisent sans connaître `AppComponent`. Par défaut, un contrôleur inerte :
 * un écran composé hors de l'application (aperçu, test) ne montre ni ne demande rien.
 */
val LocalAdsController = staticCompositionLocalOf<AdsController> { InertAdsController }

/** Aucune publicité, aucun appel : l'état d'une plateforme sans pub, figé. */
internal object InertAdsController : AdsController {
    override val state: StateFlow<AdsState> = MutableStateFlow(AdsState.UNSUPPORTED).asStateFlow()

    override fun claim(placement: AdPlacement): AdClaim = AdClaim(0L) {}

    override fun hold(reason: AdHold): AdHandle = AdHandle {}

    override fun maybeShowInterstitial(trigger: InterstitialTrigger): Boolean = false

    override fun onConsentIntroContinue() = Unit

    override fun onConsentIntroDismissed() = Unit

    override suspend fun openPrivacyOptions(): Boolean = false

    override val canOfferRewarded: StateFlow<Boolean> = MutableStateFlow(false).asStateFlow()

    override val rewardedPending: StateFlow<Boolean> = MutableStateFlow(false).asStateFlow()

    override suspend fun watchRewardedForAdFree(): RewardedResult = RewardedResult.UNAVAILABLE
}
